var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#003462;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0ZM17.735,37.793H11.647V19.475h6.089ZM14.691,16.974h-.04a3.173,3.173,0,1,1,.08-6.329,3.175,3.175,0,1,1-.04,6.329Zm25,20.819H33.6v-9.8c0-2.463-.882-4.142-3.085-4.142a3.333,3.333,0,0,0-3.124,2.227,4.17,4.17,0,0,0-.2,1.486V37.793H21.1s.08-16.6,0-18.318h6.088v2.594a6.045,6.045,0,0,1,5.487-3.024c4.006,0,7.01,2.618,7.01,8.244Zm0,0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2f822f2ddb9f1a842a0c3847d3108866.svg";
export { ForwardRef as ReactComponent };